"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialLinks = void 0;
exports.socialLinks = {
    facebook: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    x: (url) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
    linkedin: (url) => `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`,
};
